import { apiRequest } from "./apiClient";

export function getMyProfile() {
  return apiRequest("/api/me");
}

export function changeMyPassword(values) {
  return apiRequest("/api/me/password", {
    method: "PUT",
    body: JSON.stringify(values),
  });
}

